export const trainingChecklistData = [
  {
    sectionTitle: "1. Training Requirements",
    items: [
      { id: "1_1", label: "1.1", text: "Food Safety Level 2 – all relevant staff trained" },
      { id: "1_2", label: "1.2", text: "Allergen Awareness – relevant staff trained" },
      { id: "1_3", label: "1.3", text: "Manual Handling – relevant staff trained" },
      { id: "1_4", label: "1.4", text: "Health & Safety – relevant staff trained" },
      { id: "1_5", label: "1.5", text: "Fire Safety Awareness – relevant staff trained" },
      { id: "1_6", label: "1.6", text: "COSHH Awareness – relevant staff trained" },
      { id: "1_7", label: "1.7", text: "First Aid – appointed staff trained" }
    ]
  },
  {
    sectionTitle: "2. Training Records Review",
    items: [
      { id: "2_1", label: "2.1", text: "New starters have completed induction training" },
      { id: "2_2", label: "2.2", text: "Existing records are complete and up to date" },
      { id: "2_3", label: "2.3", text: "Training certificates are available for inspection" },
      { id: "2_4", label: "2.4", text: "Refresher training needs have been identified" }
    ]
  },
  {
    sectionTitle: "3. Manager Verification",
    items: [
      { id: "3_1", label: "3.1", text: "Training records reviewed and accurate" },
      { id: "3_2", label: "3.2", text: "Review completed and signed" }
    ]
  }
];
